/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import { parseJsonDateAsUtc } from '../../utils/apiDateTime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsUserSubscribeWebPushRequest
 */
export interface RevisdomAPIViewModelsUserSubscribeWebPushRequest {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserSubscribeWebPushRequest
     */
    endpoint?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserSubscribeWebPushRequest
     */
    p256dh?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsUserSubscribeWebPushRequest
     */
    auth?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof RevisdomAPIViewModelsUserSubscribeWebPushRequest
     */
    expirationTime?: Date | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsUserSubscribeWebPushRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsUserSubscribeWebPushRequest(value: object): value is RevisdomAPIViewModelsUserSubscribeWebPushRequest {
    return true;
}

export function RevisdomAPIViewModelsUserSubscribeWebPushRequestFromJSON(json: any): RevisdomAPIViewModelsUserSubscribeWebPushRequest {
    return RevisdomAPIViewModelsUserSubscribeWebPushRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserSubscribeWebPushRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsUserSubscribeWebPushRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'endpoint': json['endpoint'] == null ? undefined : json['endpoint'],
        'p256dh': json['p256dh'] == null ? undefined : json['p256dh'],
        'auth': json['auth'] == null ? undefined : json['auth'],
        'expirationTime': json['expirationTime'] == null ? undefined : (parseJsonDateAsUtc(json['expirationTime'])),
    };
}

export function RevisdomAPIViewModelsUserSubscribeWebPushRequestToJSON(json: any): RevisdomAPIViewModelsUserSubscribeWebPushRequest {
    return RevisdomAPIViewModelsUserSubscribeWebPushRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserSubscribeWebPushRequestToJSONTyped(value?: RevisdomAPIViewModelsUserSubscribeWebPushRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'endpoint': value['endpoint'],
        'p256dh': value['p256dh'],
        'auth': value['auth'],
        'expirationTime': value['expirationTime'] == null ? undefined : ((value['expirationTime'] as any).toISOString()),
    };
}

